// schemaHelpers.js
function formatDateForSchema(dateString) {
  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
      return dateString;
    }

    // Use Intl.DateTimeFormat to correctly convert to Amsterdam time
    // This handles DST automatically using the browser's timezone database
    const formatter = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Amsterdam',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
      timeZoneName: 'longOffset'
    });

    const parts = formatter.formatToParts(date);
    const get = (type) => parts.find(p => p.type === type)?.value;

    const year = get('year');
    const month = get('month');
    const day = get('day');
    const hour = get('hour');
    const minute = get('minute');
    const second = get('second');
    const tzName = get('timeZoneName'); // "GMT+01:00" or "GMT+02:00"

    // Extract offset from "GMT+01:00" format
    const offset = tzName ? tzName.replace('GMT', '') : '+01:00';

    return `${year}-${month}-${day}T${hour}:${minute}:${second}${offset}`;
  } catch (error) {
    console.warn('Date formatting error:', error);
    const date = new Date(dateString);
    return isNaN(date.getTime()) ? dateString : date.toISOString();
  }
}

export function getTimetableSchema(movies) {
    return {
      "@context": "https://schema.org",
      "@graph": movies.map((movie) => ({
        "@type": "ScreeningEvent",
        "name": `${movie.name || movie.title} - Filmvoorstelling`,
        "description": `Filmvoorstelling van ${movie.name || movie.title} in Filmtheater Kriterion Amsterdam`,
        "startDate": formatDateForSchema(movie.starts_at),
        "endDate": formatDateForSchema(movie.ends_at),
        "workPresented": {
          "@type": "Movie",
          "name": movie.name || movie.title,
          "director": movie.director ? {
            "@type": "Person",
            "name": movie.director
          } : undefined,
          "duration": movie.duration ? `PT${movie.duration}M` : undefined,
          "inLanguage": movie.spoken_languages || undefined,
          "subtitleLanguage": movie.subtitle_languages || undefined,
          "description": `${movie.name || movie.title}${movie.director ? ` - Regie: ${movie.director}` : ''}`
        },
        "location": {
          "@type": "MovieTheater",
          "name": "Filmtheater Kriterion",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "Roetersstraat 170",
            "addressLocality": "Amsterdam",
            "postalCode": "1018 WE",
            "addressCountry": "NL",
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": 52.36250,
            "longitude": 4.91056
          }
        },
        "eventStatus": "https://schema.org/EventScheduled",
        "eventAttendanceMode": "https://schema.org/OfflineEventAttendanceMode",
        "offers": {
          "@type": "Offer",
          "url": "https://tickets.kriterion.nl/kriterion/nl/flow_configs/webshop/steps/start/show/"+ movie.id,
          "availability": "https://schema.org/InStock",
          "priceCurrency": "EUR"
        },
        "organizer": {
          "@type": "Organization",
          "name": "Filmtheater Kriterion",
          "url": "https://www.kriterion.nl",
        },
        "performer": {
          "@type": "Organization", 
          "name": "Filmtheater Kriterion"
        }
      })).filter(movie => movie.workPresented.name), // Filter out entries without movie names
    };
  }

export function getOrganizationSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "MovieTheater",
    "name": "Filmtheater Kriterion",
    "url": "https://www.kriterion.nl",
    "logo": "https://www.kriterion.nl/favicon_krit.ico",
    "image": "https://www.kriterion.nl/favicon_krit.ico",
    "description": "Filmtheater Kriterion is een onafhankelijke filmzaal in Amsterdam, gerund door studenten. Wij vertonen arthouse films, documentaires en commerciële films.",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Roetersstraat 170",
      "addressLocality": "Amsterdam",
      "postalCode": "1018 WE",
      "addressCountry": "NL"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 52.36250,
      "longitude": 4.91056
    },
    "telephone": "+31-20-623-1708",
    "priceRange": "€€",
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": [
          "Sunday",
          "Monday",
          "Tuesday", 
          "Wednesday",
          "Thursday"
        ],
        "opens": "12:00",
        "closes": "01:00"
      },
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": [
          "Friday",
          "Saturday"
        ],
        "opens": "12:00",
        "closes": "03:00"
      }
    ],
    "sameAs": [
      "https://www.facebook.com/kriterionamsterdam",
      "https://www.instagram.com/kriterionamsterdam"
    ]
  };
}

export function getWebsiteSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "Filmtheater Kriterion",
    "url": "https://www.kriterion.nl",
    "description": "Filmtheater Kriterion Amsterdam - Ontdek actuele films, filmprogramma's en evenementen.",
    "inLanguage": "nl-NL"
  };
}
  
  
  